import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeInputs", "allDayCheckbox", "timeUnknownField"]

  connect() {
    this.toggleTimeInputs()
  }

  toggleTimeInputs() {
    const isAllDay = this.allDayCheckboxTarget.checked

    if (isAllDay) {
      this.timeInputsTarget.classList.add("hidden")
      this.timeUnknownFieldTarget.value = "true"
    } else {
      this.timeInputsTarget.classList.remove("hidden")
      this.timeUnknownFieldTarget.value = "false"
    }
  }
}

